import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { CustomAxiosResponse } from '@/api/AxiosResponse';
import { ResCoinType } from '@/types/coin-type/read';

export const readCoinType = async (): Promise<CustomAxiosResponse<ResCoinType>> => {
  const payload = {
    path: '/coin-type/list',
    body: {},
  };
  return sendRequest(payload, 'readCoinType', axiosPost);
};
